
import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import Tooltip from '@mui/material/Tooltip';

export const CopyableCell = ({ value, children, tooltipTitle, tooltipPlacement = 'top-start', style }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = (e) => {
        e.stopPropagation();
        navigator.clipboard.writeText(value == null ? '' : String(value));
        setCopied(true);
        setTimeout(() => setCopied(false), 5000);
    };

    const titleContent = tooltipTitle ?? children ?? value;
    const displayContent = children ?? value;

    return (
        <Tooltip
            title={
                <span
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        maxWidth: 350,
                        whiteSpace: 'normal',
                        overflowWrap: 'break-word'
                    }}
                >
                    <span style={{ marginRight: 8, wordBreak: 'break-all' }}>{titleContent}</span>
                    <IconButton
                        size="small"
                        style={{ padding: 2 }}
                        onClick={handleCopy}
                    >
                        {copied ? <CheckIcon style={{ color: 'white', fontSize: 12 }} /> : <ContentCopyIcon style={{ color: 'white', fontSize: 12 }} />}
                    </IconButton>
                </span>

            }
            placement={tooltipPlacement}
            arrow
        >
            <span style={style}>
                {displayContent}
            </span>
        </Tooltip>
    );
};